export type SelectOptionItem<Data = unknown> = {
  label: string;
  value: Data;
};

export function getCurrentItem<Data>(
  data: SelectOptionItem<Data>[],
  search: string
) {
  return data.find(
    (item) =>
      item.value === search ||
      String(item.value) === search ||
      item.label === search
  );
}

export function hasExactMatch<Data>(
  options: SelectOptionItem<Data>[],
  search: string
) {
  const trimmed = search.trim();
  if (!trimmed) {
    return true;
  }
  const lower = trimmed.toLowerCase();
  return options.some(
    (item) =>
      item.label.toLowerCase() === lower ||
      String(item.value).toLowerCase() === lower
  );
}
